import { createSelector } from 'reselect';
import { State } from 'store';

const getTransactionHandleSystemState = (state: State) => state.transactions.handle.system;

export const getSystemTransactionHandleStatus = createSelector(
  getTransactionHandleSystemState,
  system => system.status,
);
